import React from 'react';
import { Building2 } from 'lucide-react';

export function WhoSection(): JSX.Element {
  return (
    <section id='who' className='bg-muted/40 py-24 md:py-32'>
      <div className='mx-auto max-w-3xl px-6 text-center'>
        <div className='mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-teal/20'>
          <Building2 className='h-7 w-7 text-foreground' />
        </div>

        <h2
          className='mt-8 text-3xl font-bold tracking-tight text-foreground md:text-4xl text-balance'
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          Designed for Third-Party Property Management Firms
        </h2>

        <p className='mt-6 text-lg leading-relaxed text-muted-foreground text-pretty'>
          Strada supports third-party property management firms responsible
          for large commercial lease portfolios requiring centralized
          visibility into lease rights and CAM obligations.
        </p>
      </div>
    </section>
  );
}
